export const mockData = {
  stats: [
    { value: "5,000+", label: "Active Users" },
    { value: "50,000+", label: "Returns Processed" },
    { value: "4.9/5", label: "Customer Rating" }
  ],

  steps: [
    {
      number: "01",
      icon: "package",
      title: "Schedule Your Pickup",
      description: "Customers choose a pickup date during booking. Pickups are Monday–Friday."
    },
    {
      number: "02",
      icon: "clock",
      title: "Upload Your Return Labels",
      description: "Upload one prepaid return label per package. One label = one package. Multiple items can be in one package if covered by one label."
    },
    {
      number: "03",
      icon: "check",
      title: "Drop at Selected Location",
      description: "Drop your returns to your selected location during your pickup window. ReturnPal will pick up packages and deliver to authorized carrier locations within 48 hours."
    }
  ],

  features: [
    {
      icon: "clock",
      title: "Save Hours Every Month",
      description: "Eliminate trips to shipping centers and long wait times. Get your time back for what matters most."
    },
    {
      icon: "mappin",
      title: "Office & Coworking Integration",
      description: "Seamless pickup from your workspace, whether you're at a traditional office or flexible coworking space."
    },
    {
      icon: "shield",
      title: "Fully Insured & Tracked",
      description: "Every return is insured and tracked from pickup to delivery. Real-time updates via our mobile app."
    },
    {
      icon: "users",
      title: "Team Plans Available",
      description: "Special pricing for companies and teams. Simplify returns management for your entire organization."
    },
    {
      icon: "package",
      title: "All Carriers Supported",
      description: "We handle returns for all major carriers—UPS, FedEx, Amazon-approved locations. One service for everything."
    },
    {
      icon: "check",
      title: "Professional Packaging",
      description: "We ensure your items are properly packaged and labeled. No more worry about rejected returns."
    }
  ],

  pricingPlans: [
    {
      name: "Starter",
      price: "19",
      description: "Perfect for occasional online shoppers",
      features: [
        "3 pickups per month",
        "Next-day pickup scheduling",
        "All carriers supported",
        "Real-time tracking",
        "Email support"
      ],
      cta: "Start Free Trial",
      popular: false
    },
    {
      name: "Professional",
      price: "39",
      description: "Ideal for frequent online shoppers",
      features: [
        "10 pickups per month",
        "Same-day pickup available",
        "All carriers supported",
        "Priority real-time tracking",
        "24/7 phone & chat support",
        "Package consolidation"
      ],
      cta: "Start Free Trial",
      popular: true
    },
    {
      name: "Business",
      price: "99",
      description: "Best for teams and companies",
      features: [
        "Unlimited pickups",
        "Immediate pickup scheduling",
        "All carriers supported",
        "Dedicated account manager",
        "24/7 priority support",
        "Team dashboard & analytics",
        "Custom invoicing"
      ],
      cta: "Contact Sales",
      popular: false
    }
  ],

  faqs: [
    {
      question: "How does ReturnPal work?",
      answer: "Schedule a pickup date and select your preferred weekday collection window. Upload one prepaid return label per package. Drop your returns to your selected location before your pickup window. ReturnPal will pick up packages and deliver them to authorized carrier locations within 48 calendar hours."
    },
    {
      question: "Does ReturnPal cover residential areas?",
      answer: "At this time, ReturnPal is focusing on professional office buildings, however if customers want to bring returned items from home they can use their office/business location for scheduling pick up."
    },
    {
      question: "Which carriers do you support?",
      answer: "ReturnPal delivers prepaid return packages to: UPS, FedEx, and Amazon-approved drop-off locations. Retail store returns are not supported."
    },
    {
      question: "What if my return needs packaging?",
      answer: "Packaging assistance is available upon request during booking. Each package must have a valid prepaid return label."
    },
    {
      question: "Is my return insured?",
      answer: "ReturnPal's liability is limited to $100 per package, as outlined in our Terms. Carrier liability begins once the package is scanned by the carrier."
    },
    {
      question: "What areas do you service?",
      answer: "ReturnPal currently operates within approved commercial office clusters. Service availability is limited to designated buildings."
    },
    {
      question: "What are your service hours?",
      answer: "Pickups are available Monday–Friday only. Carrier drop-off occurs within 48 calendar hours of collection."
    },
    {
      question: "What is your package limit?",
      answer: "Maximum 10 packages per pickup. Package size limits: Standard packages up to 50 lbs and 150 inches (length + width + height combined). Oversized packages available with an $8 fee per package. All packages must have a valid prepaid return label or ReturnPal QR code."
    }
  ]
};
